{
  "new-app-version-notification": {
    "buttons": {
      "update": "Cập nhật"
    },
    "text": {
      "new-version-available": "Đã có phiên bản mới"
    }
  }
}
